import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";

export default {
  state: false,
  init() {
    $('.navbar-menu > ul > li').hover(function(){
      $('.page-mask').stop(true, true).show();
      $(this).find('> .sub-menu').stop(true, true).fadeIn();
    }, function(){
      $('.page-mask').stop(true, true).fadeOut();
      $(this).find('> .sub-menu').stop(true, true).fadeOut();
    })
    
    if($('#navigation-docs').length){
      const target = document.querySelector(".menu-docs-navigation-container");
      console.log('target: ', target);


      $(".hamburger").on("click",  (e) => {
   
        if(this.state){
          console.log('enable');
          enableBodyScroll(target);
        } else {
          console.log('disable')
          
          disableBodyScroll(target);
        }
        this.state = !this.state; 
        $('html').toggleClass('hidden');
        $(e.delegateTarget).toggleClass('is-active');
        $(".nav-mobile-docs").toggleClass("is-active");

      });
    }
   
  },
};
